module.exports = __webpack_public_path__ + "img/earth.383fc36a.gif";